module.exports = __webpack_public_path__ + "static/img/pause.98345de.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/audio/pause.png
// module id = RC1q
// module chunks = 1